import { useResidentModalsApi } from '@/components/modals/ResidentModals'
import { selectUserConfiguration } from '@/features/domain/user'
import { useSelector } from 'react-redux'

export function useExportOrderButtonData(
  orders: uui.domain.client.rm.ExtendedOrderStep[],
  orderIds: string[],
) {
  const {
    exportOrders: { show: showExportOrderModal },
  } = useResidentModalsApi()

  const { startFromDate, planType } = useSelector(selectUserConfiguration)

  // Get date from the first order - it has dateAsString when assigned, or we use startFromDate as fallback for unassigned
  const firstOrder = orders[0]
  const date = firstOrder?.isUnassigned
    ? startFromDate
    : (firstOrder?.dateAsString ?? startFromDate)

  const orderInArchivedDay = date < startFromDate

  return {
    exportOrders: () =>
      showExportOrderModal(
        'default',
        orderIds,
        orders,
        date,
        planType === 'simulation' ? 'simulation' : orderInArchivedDay ? 'archived' : 'operations',
      ),
  }
}
